export const enum CommonConstants {
  EXIST = 'exist',
  NEW = 'new',
  TIMEOUT = 30000,
  MAX_TIMEOUT = 40000
}
